document.addEventListener('DOMContentLoaded', function () { 

  if (typeof window_customer !== 'undefined') {
    var address = window_customer;
  }

  document.querySelectorAll('select.addressField').forEach(function(select) {
    select.addEventListener('change', function (e) {

      document.querySelectorAll('.addnetterm').forEach(function(el) {
        el.classList.remove('selected_button_add');
      });

      document.querySelectorAll('.address_edit_form_ajax .error_msg').forEach(function(el) {
        el.remove();
      });

      var selectedOption = this.options[this.selectedIndex];
      var button_address = selectedOption
        ? selectedOption.getAttribute('data-id')
        : null;

      var take_address = [];

      if (address && Array.isArray(address)) {
        take_address = address.filter(function(cont) {
          if (cont.id != null) {
            return cont.id == button_address;
          }
        });
      }

      document.querySelectorAll('.addressadd_term .form-field').forEach(function(k) {

        var input = k.querySelector('.form-field-input');
        var data = input ? input.getAttribute('data-add') : null;

        if (take_address.length > 0) {

          if (input) {
            input.value = take_address[0][data] || '';
            input.dispatchEvent(new Event('click', { bubbles: true }));
          }

          var zipField = document.querySelector('.shipping_step #address_zip_new');
          if (zipField) {
            zipField.value = take_address[0]['zip'];
          }

          if (take_address[0]['province'] == null) {

            var provinceSelect = k.querySelector('.form-field-input[data-add="province"]');
            if (provinceSelect && provinceSelect.tagName === 'SELECT') {
              provinceSelect.selectedIndex = 0;
            }

            var shipProvince = document.querySelector('.shipping_step #address_province_new');
            if (shipProvince) {
              shipProvince.selectedIndex = 0;
            }

          } else {
            var shipProvince2 = document.querySelector('.shipping_step #address_province_new');
            if (shipProvince2) {
              shipProvince2.value = take_address[0]['province'];
            }
          }

        } else {

          if (input && input.tagName === 'INPUT') {
            input.value = '';
          }

          if (input && input.tagName === 'SELECT') {
            input.selectedIndex = 0;
          }

          var shipProvince3 = document.querySelector('.shipping_step #address_province_new');
          if (shipProvince3) {
            shipProvince3.selectedIndex = 0;
          }

          var shipZip3 = document.querySelector('.shipping_step #address_zip_new');
          if (shipZip3) {
            shipZip3.value = '';
          }
        }
      });
    });
  });

  function cartUpdate() {

    var cartForm = document.querySelector('.cart-form');
    var formData = '';

    if (cartForm) {
      formData = new URLSearchParams(new FormData(cartForm)).toString();
    }

    fetch('/cart/update.js?csapp=aiod', {
      method: 'GET',
      credentials: 'same-origin'
    })
    .then(function () {
      return fetch('/cart.js?csapp=aiod', {
        credentials: 'same-origin'
      });
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      console.log(cart);
      window.update_cart_data = cart;
    });
  }

  document.body.addEventListener('click', function(e) {

    var normalCheckout = e.target.closest('.normal_checkout');
    if (normalCheckout) {
      e.preventDefault();
      recent_click = 'normal_checkout';
    }

    var nettermCustomer = e.target.closest('.netterm_customer');
    if (nettermCustomer) {
      e.preventDefault();
      recent_click = 'netterm_customer';

      var nettermTag = document.querySelector('.netterm_tag');
      if (nettermTag) {
        nettermTag.classList.add('popup-active');
        nettermTag.classList.remove('error_msg_dis');
      }

      var overlay = document.querySelector('.overlay');
      if (overlay) {
        overlay.classList.add('popup-active');
      }

      document.body.classList.add('overflow_hidden');

      if (AIOD_discount) {
        setTimeout(function () {
          document.querySelectorAll('.netterm_submit').forEach(function(btn) {
            btn.removeAttribute('disabled');
            btn.classList.remove('btn--loading');
            btn.querySelector('.loading__spinner').classList.add('hidden');
          });
        }, 3000);
      } else {
        document.querySelectorAll('.netterm_submit').forEach(function(btn) {
          btn.removeAttribute('disabled');
          btn.classList.remove('btn--loading');
          btn.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      cartUpdate();
    }
  });

  if (document.querySelectorAll('.popup-active').length > 0) {
    document.body.classList.add('overflow_hidden');
  }

  /* ===============================
     CONTACT FORM SUBMIT
  =============================== */
  var contactForm = document.getElementById('contact_form');

  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {

      var form = contactForm;
      var x = true;

      var em = form.querySelector('#ContactFormEmail');
      var masg = form.querySelector('#ContactFormMessage');

      form.querySelectorAll('.error_msg').forEach(function (el) {
        el.remove();
      });

      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

      if (em.value.trim() === '' || !regex.test(em.value)) {
        em.parentElement.insertAdjacentHTML(
          'beforeend',
          '<span class="error_msg">Contact e-mail required</span>'
        );
        em.style.borderBottom = '1px solid red';
        x = false;
      } else {
        em.style.borderBottom = '1px solid #e5e5e5';
      }

      if (masg.value.trim() === '') {
        masg.parentElement.insertAdjacentHTML(
          'beforeend',
          '<span class="error_msg">Contact Message required</span>'
        );
        masg.style.borderBottom = '1px solid red';
        x = false;
      } else {
        masg.style.borderBottom = '1px solid #e5e5e5';
      }

      if (x === false) {
        e.preventDefault();
        return false;
      }
    });
  }

  /* ===============================
     ADDRESS EDIT FORM SUBMIT (DELEGATED)
  =============================== */
  document.body.addEventListener('submit', function (e) {

    if (!e.target.classList.contains('address_edit_form_ajax')) {
      return;
    }

    e.preventDefault();

    var form = e.target;
    var x = true;

    var zip = form.querySelector('.form-field-input[name="address[zip]"]');
    var f_name = form.querySelector('.form-field-input[name="address[first_name]"]');
    var l_name = form.querySelector('.form-field-input[name="address[last_name]"]');
    var add_1 = form.querySelector('.form-field-input[name="address[address1]"]');
    var city = form.querySelector('.form-field-input[name="address[city]"]');
    var email = form.querySelector('.form-field-input[name="address[email]"]');
    var phone = form.querySelector('.form-field-input[name="address[phone]"]');

    var reg = new RegExp('^[0-9]*$');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    form.querySelectorAll('.error_msg').forEach(function (el) {
      el.remove();
    });

    if (email.value.trim() === '' || !regex.test(email.value)) {
      email.parentElement.insertAdjacentHTML(
        'beforeend',
        '<span class="error_msg">This field is required</span>'
      );
      x = false;
    }

    if (f_name.value.trim() === '') {
      f_name.parentElement.insertAdjacentHTML(
        'beforeend',
        '<span class="error_msg">This field is required</span>'
      );
      x = false;
    }

    if (l_name.value.trim() === '') {
      l_name.parentElement.insertAdjacentHTML(
        'beforeend',
        '<span class="error_msg">This field is required</span>'
      );
      x = false;
    }

    if (add_1.value.trim() === '') {
      add_1.parentElement.insertAdjacentHTML(
        'beforeend',
        '<span class="error_msg">This field is required</span>'
      );
      x = false;
    }

    if (city.value.trim() === '') {
      city.parentElement.insertAdjacentHTML(
        'beforeend',
        '<span class="error_msg">This field is required</span>'
      );
      x = false;
    }

    if (zip.value.trim() === '') {
      zip.parentElement.insertAdjacentHTML(
        'beforeend',
        '<span class="error_msg">This field is required</span>'
      );
      x = false;
    }

    if (phone.value.trim() === '' || !reg.test(phone.value)) {
      phone.parentElement.insertAdjacentHTML(
        'beforeend',
        '<span class="error_msg">This field is required</span>'
      );
      x = false;
    }

    if (x === false) {
      return false;
    }

    var rateBtn = document.querySelector('.get-rates_new');
    if (rateBtn) {
      rateBtn.click();
    }
  });

  /* ===============================
     CART NOTE LEAVE CHANGE
  =============================== */
  var cartNoteLeave = document.getElementById('cart_note_leave');

  if (cartNoteLeave) {
    cartNoteLeave.addEventListener('change', function (e) {

      //     if (this.checked) {
      //       this.setAttribute('value', 'Yes');
      //     } else {
      //       this.setAttribute('value','No');
      //     }
      //     cartUpdate();

      var yes_no =
        document.querySelectorAll('#cart_note_leave:checked').length
          ? 'Yes'
          : 'No';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: 'attributes[Authority To Leave]=' + yes_no
      })
      .then(function () {
        console.log('Cart Done');
      });
    });
  }

  /* ===============================
     ZIP SYNC
  =============================== */
  document.querySelectorAll('.AddressZipNew').forEach(function (el) {
    el.addEventListener('keyup', function (e) {
      var zipTarget = document.querySelector('.shipping_step #address_zip_new');
      if (zipTarget) {
        zipTarget.value = el.value;
      }
    });

    el.addEventListener('change', function (e) {
      var zipTarget = document.querySelector('.shipping_step #address_zip_new');
      if (zipTarget) {
        zipTarget.value = el.value;
      }
    });
  });

  /* ===============================
     PROVINCE SYNC
  =============================== */
  document.querySelectorAll('.AddressProvince').forEach(function (el) {
    el.addEventListener('keyup', function (e) {
      var provTarget = document.querySelector('.shipping_step #address_province_new');
      if (provTarget) {
        provTarget.value = el.value;
      }
    });

    el.addEventListener('change', function (e) {
      var provTarget = document.querySelector('.shipping_step #address_province_new');
      if (provTarget) {
        provTarget.value = el.value;
      }
    });
  });

  /* ===============================
     POPUP CLOSE (DELEGATED)
  =============================== */
  document.body.addEventListener('click', function (e) {

    var popupCloser = e.target.closest('.popup-closer, .overlay');
    if (!popupCloser) return;

    e.preventDefault();

    var poupPosition = document.querySelector('.poup_position');
    if (poupPosition && !poupPosition.classList.contains('processing')) {

      var activePopup = document.querySelector('.popup-active');
      if (activePopup) {
        activePopup.getAttribute('data-popup');
      }

      var csPopup = popupCloser.closest('.cs-popup');
      if (csPopup) {
        csPopup.classList.remove('popup-active');
      }

      var overlay = document.querySelector('.overlay');
      if (overlay) {
        overlay.classList.remove('popup-active');
      }

      if (poupPosition) {
        poupPosition.classList.remove('popup-active');
      }

      document.body.classList.remove('overflow_hidden');

      document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
        btn.removeAttribute('disabled');
      });
    }
  });

  /* ===============================
     GO TO GIFT
  =============================== */
  document.body.addEventListener('click', function (e) {

    var goToGift = e.target.closest('#go_to_the_gift');
    if (!goToGift) return;

    e.preventDefault();

    var shippingStep = document.querySelector('.shipping_step');
    var giftStep = document.querySelector('.gift_step');

    if (shippingStep) shippingStep.style.display = 'none';
    if (giftStep) giftStep.style.display = 'block';
  });

  /* ===============================
     BACK BUTTON NAVIGATION
  =============================== */
  document.body.addEventListener('click', function (e) {

    var backBtn = e.target.closest('.back-btn');
    if (!backBtn) return;

    e.preventDefault();

    var cur = backBtn.getAttribute('data-step');

    var parent = backBtn.parentElement;
    var nextBtn = parent ? parent.querySelector('.next-btn') : null;
    var next = nextBtn ? nextBtn.getAttribute('data-step') : null;

    if (next) {
      var nextProcess = document.querySelector('.process[data-step="' + next + '"]');
      if (nextProcess) nextProcess.style.display = 'none';
    }

    if (cur) {
      var curProcess = document.querySelector('.process[data-step="' + cur + '"]');
      if (curProcess) curProcess.style.display = 'block';
    }
  });

  document.body.addEventListener('click', function (e) {

    var submitGift = e.target.closest('#submit_gift');
    if (!submitGift) return;

    e.preventDefault();

    var provinceCode = {
      "Australian Capital Territory": "ACT",
      "New South Wales": "NSW",
      "Northern Territory": "NT",
      "Queensland": "QLD",
      "South Australia": "SA",
      "Tasmania": "TAS",
      "Victoria": "VIC",
      "Western Australia": "WA"
    };

    var gift_number = document.getElementById('gift_number').value;
    var gift_date = document.getElementById('gift_month').value;
    var reg = new RegExp('^[0-9]*$');

    var shipForm = document.querySelector('.address_edit_form_ajax');

    var email_or_phone = shipForm.querySelector('input[name="address[email]"]').value;
    var first_name = shipForm.querySelector('input[name="address[first_name]"]').value;
    var last_name = shipForm.querySelector('input[name="address[last_name]"]').value;
    var address1 = shipForm.querySelector('input[name="address[address1]"]').value;
    var address2 = shipForm.querySelector('input[name="address[address2]"]').value;
    var city = shipForm.querySelector('input[name="address[city]"]').value;
    var country = shipForm.querySelector('select[name="address[country]"]').value;
    var province = shipForm.querySelector('select[name="address[province]"]').value;
    var zip = shipForm.querySelector('input[name="address[zip]"]').value;
    var phone = shipForm.querySelector('input[name="address[phone]"]').value;

    normal_checkout = false;

    var x = true;
    document.querySelector('.gift_step .errorMsg').innerHTML = '';

    if (gift_number == '') {
      document.querySelector('.gift_step .errorMsg').innerHTML = 'Please add the gift card number';
      x = false;
      return false;
    }

    if (!reg.test(gift_number)) {
      document.querySelector('.gift_step .errorMsg').innerHTML = 'Please valid gift card number';
      x = false;
      return false;
    }

    if (gift_date == '') {
      document.querySelector('.gift_step .errorMsg').innerHTML = 'Please select Expired Date';
      x = false;
      return false;
    }

    if (x == false) {
      return false;
    }

    if (x == true) {

      var shipping_name_first;
      var shipping_price_first;

      if ((free_shipping == false && AIOD_discount == false) ||
          (free_shipping == false && AIOD_discount == true)) {

        var checkedRate = document.querySelector('[name="shipping_rates"]:checked');
        shipping_name_first = checkedRate.getAttribute('data-shipping-name');
        shipping_price_first = Number(
          checkedRate.getAttribute('data-shipping-price').replace('$','').replace('AUD','')
        );

      } else if (free_shipping == true && AIOD_discount == true) {
        shipping_name_first = free_shipping_name;
        shipping_price_first = 0;
      }

      var formdata = {};
      var formElements = new FormData(shipForm);

      formElements.forEach(function (value, key) {
        if (key.indexOf('address[') > -1) {
          var new_name = key.replace('address[','').replace(']','');
          formdata[new_name] = value;
        }
      });

      document.getElementById('submit_gift').classList.add('btn--loading');
      document.getElementById('submit_gift').querySelector('.loading__spinner').classList.remove('hidden');
      document.getElementById('submit_netterm').setAttribute('disabled','disabled');
      document.getElementById('submit_gift').setAttribute('disabled','disabled');

      document.querySelectorAll('.ship_form_msg').forEach(function (el) {
        el.remove();
      });

      formdata['countryCode'] = 'AU';
      formdata['provinceCode'] = provinceCode[
        shipForm.querySelector('[name="address[province]"]').value
      ];

      var data;

      if (free_shipping == false && AIOD_discount == false) {
        data = {
          cdata: window.update_cart_data,
          shipping_address: formdata,
          shop: window.prvt_apk_data.store_id,
          shipping_name: shipping_name_first,
          shipping_rate: shipping_price_first,
          voucher_number: gift_number,
          gift_card_expiry: gift_date,
          email_or_phone: email_or_phone
        };
      } else {
        data = {
          cdata: window.update_cart_data,
          shipping_address: formdata,
          shop: window.prvt_apk_data.store_id,
          shipping_name: shipping_name_first,
          shipping_rate: shipping_price_first,
          voucher_number: gift_number,
          gift_card_expiry: gift_date,
          email_or_phone: email_or_phone,
          draft_order_id: draft_order_id
        };
      }

      console.log(window.update_cart_data);
      console.log(data);

      fetch('https://webapp.wheelandbarrow.com.au/api/create-draft-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function (res) { return res.json(); })
      .then(function (result) {

        if (result.success) {

          document.querySelectorAll('.netterm_submit').forEach(function (btn) {
            btn.classList.remove('btn--loading');
            btn.querySelector('.loading__spinner').classList.add('hidden');
          });

          shipForm.reset();

          if (result.cart_clear == true) {

            document.querySelectorAll('.cs-popup').forEach(el => el.style.display = 'none');
            document.querySelector('.poup_position').classList.add('btn--loading');
            document.querySelector('.poup_position .loading__spinner').classList.remove('hidden');
            document.querySelectorAll('.netterm_popup-main').forEach(el => el.style.display = 'none');

            fetch('/cart/clear', { method: 'POST' })
              .then(function () {
                window.location.href = result.redirect_url;
              });

          } else {

            document.querySelector('.gift_step .errorMsg').innerHTML =
              'You gift voucher amount is less...';

            setTimeout(function () {

              document.querySelectorAll('.cs-popup').forEach(el => el.style.display = 'none');
              document.querySelector('.poup_position').classList.add('btn--loading');
              document.querySelector('.poup_position .loading__spinner').classList.remove('hidden');
              document.querySelectorAll('.netterm_popup-main').forEach(el => el.style.display = 'none');

              window.location.href =
                result.redirect_url +
                '?step=contact_information' +
                '&checkout[email]=' + email_or_phone +
                '&checkout[shipping_address][first_name]=' + first_name +
                '&checkout[shipping_address][last_name]=' + last_name +
                '&checkout[shipping_address][address1]=' + address1 +
                '&checkout[shipping_address][address2]=' + address2 +
                '&checkout[shipping_address][city]=' + city +
                '&checkout[shipping_address][zip]=' + zip +
                '&checkout[shipping_address][country]=' + country +
                '&checkout[shipping_address][province]=' + province +
                '&checkout[shipping_address][phone]=' + phone;

            }, 1000);
          }

        } else {
          document.getElementById('submit_gift').classList.add('btn--loading');
          document.getElementById('submit_gift').querySelector('.loading__spinner').classList.remove('hidden');
          document.querySelector('.gift_step .errorMsg').innerHTML = result.message;
        }

        document.querySelectorAll('.netterm_submit').forEach(function (btn) {
          btn.classList.remove('btn--loading');
          btn.querySelector('.loading__spinner').classList.add('hidden');
        });

        document.getElementById('submit_gift').removeAttribute('disabled');
        document.getElementById('submit_netterm').removeAttribute('disabled');
      })
      .catch(function (err) {
        document.getElementById('submit_gift').classList.remove('btn--loading');
        document.getElementById('submit_gift').querySelector('.loading__spinner').classList.add('hidden');
        document.querySelector('.gift_step .errorMsg').innerHTML = err;
        document.getElementById('submit_gift').removeAttribute('disabled');
        document.getElementById('submit_netterm').removeAttribute('disabled');
      });

      return false;
    }
  });

// note: this is not a drop-in solution yet, merely a demo, with an id instead of reusable class for the wrapper etc.
  const showOriginalFieldForDemo = true;

  // see https://codepen.io/Connum/pen/xxPVQQO?editors=0010
  // for detection

  const fieldDateOfBirth = document.getElementById('gift_month');
  if (fieldDateOfBirth) {

    let month_names = [
      'January','February','March','April','May','June',
      'July','August','September','October','November','December'
    ];

    if (window.Intl && window.Intl.DateTimeFormat) {
      try {
        var formatter = new window.Intl.DateTimeFormat([], { month: 'long', timeZone: 'UTC' });
        var months = [1,2,3,4,5,6,7,8,9,10,11,12].map(function(month){
          var mm = month < 10 ? '0' + month : month;
          return new Date('0000-' + mm + '-01T00:00:00+00:00');
        });
        month_names = months.map(function(date){
          return formatter.format(date);
        });
      } catch(e) {}
    }

    const dateWrapper = document.createElement('div');
    dateWrapper.id = 'date-select-wrapper';
    dateWrapper.classList.add('form-row','form-field');
    fieldDateOfBirth.parentNode.appendChild(dateWrapper);

    const s_main_date = document.createElement('div');
    s_main_date.classList.add('select');
    const s_main_month = document.createElement('div');
    s_main_month.classList.add('select');
    const s_main_year = document.createElement('div');
    s_main_year.classList.add('select');

    const dateFieldDay = document.createElement('select');
    const dateFieldMonth = document.createElement('select');
    const dateFieldYear = document.createElement('select');

    const dateFields = [dateFieldYear, dateFieldMonth, dateFieldDay];

    const main_date = document.createElement('div');
    main_date.classList.add('form-field','form-field-select-wrapper');
    const main_month = document.createElement('div');
    main_month.classList.add('form-field','form-field-select-wrapper');
    const main_year = document.createElement('div');
    main_year.classList.add('form-field','form-field-select-wrapper');

    dateFields.forEach(function(f){
      f.classList.add('form-field-input','form-field-select','form-field-filled','form-control','form-control--select');
    });

    const emptyDayOption = document.createElement('option');
    emptyDayOption.value = '';
    emptyDayOption.textContent = 'Day';
    dateFieldDay.add(emptyDayOption);

    const emptyMonthOption = document.createElement('option');
    emptyMonthOption.value = '';
    emptyMonthOption.textContent = 'Month';
    dateFieldMonth.add(emptyMonthOption);

    const emptyYearOption = document.createElement('option');
    emptyYearOption.value = '';
    emptyYearOption.textContent = 'Year';
    dateFieldYear.add(emptyYearOption);

    const dayOptions = [emptyDayOption];
    for (var i = 1; i <= 31; i++) {
      var newOption = document.createElement('option');
      newOption.value = (i < 10 ? '0' : '') + i;
      newOption.textContent = i;
      dayOptions.push(newOption);
      dateFieldDay.add(newOption);
    }

    const monthOptions = [emptyMonthOption];
    for (var i = 0; i < month_names.length; i++) {
      var newOption = document.createElement('option');
      newOption.value = (i < 9 ? '0' : '') + (i + 1);
      newOption.textContent = month_names[i];
      monthOptions.push(newOption);
      dateFieldMonth.add(newOption);
    }

    const yearStart = new Date().getFullYear();
    const yearEnd = yearStart + 8;
    const yearOptions = [emptyYearOption];
    for (var i = yearStart; i <= yearEnd; i++) {
      var newOption = document.createElement('option');
      newOption.value = i;
      newOption.textContent = i;
      yearOptions.push(newOption);
      dateFieldYear.add(newOption);
    }

    var svg = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret-down icon--medium" viewBox="0 0 20 20" fill="none">
      <path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>`;

    s_main_date.appendChild(dateFieldDay);
    s_main_month.appendChild(dateFieldMonth);
    s_main_year.appendChild(dateFieldYear);

    s_main_date.insertAdjacentHTML('beforeend', svg);
    s_main_month.insertAdjacentHTML('beforeend', svg);
    s_main_year.insertAdjacentHTML('beforeend', svg);

    main_date.appendChild(s_main_date);
    main_month.appendChild(s_main_month);
    main_year.appendChild(s_main_year);

    main_date.insertAdjacentHTML('afterbegin','<label class="form-label">Date</label>');
    main_month.insertAdjacentHTML('afterbegin','<label class="form-label">Month</label>');
    main_year.insertAdjacentHTML('afterbegin','<label class="form-label">Year</label>');

    dateWrapper.appendChild(main_date);
    dateWrapper.appendChild(main_month);
    dateWrapper.appendChild(main_year);

    const dateChangeHandler = function () {

      const month = parseInt(dateFieldMonth.value, 10);
      const year = parseInt(dateFieldYear.value, 10);
      let maxDays = 31;

      if (month === 2) {
        const isLeapYear =
          ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
        maxDays = isLeapYear ? 29 : 28;
      } else if ([2,4,6,9,11].indexOf(month) >= 0) {
        maxDays = 30;
      }

      dayOptions.filter(function(o, i){
        o.hidden = i > maxDays;
        if (o.hidden && o.selected) {
          emptyDayOption.selected = true;
        }
      });

      let allSet = true;
      dateFields.forEach(function(field){
        const isEmpty = !field.value;
        if (isEmpty) allSet = false;
        field.classList[isEmpty ? 'add' : 'remove']('show-placeholder');
      });

      if (allSet) {
        fieldDateOfBirth.value = dateFields.map(function(f){
          return f.value;
        }).join('-');
      } else {
        fieldDateOfBirth.value = '';
      }
    };

    if (fieldDateOfBirth.value) {
      const ymd = fieldDateOfBirth.value.split('-');
      yearOptions.filter(function(o){
        if (o.value === ymd[0]) o.selected = true;
      });
      monthOptions[parseInt(ymd[1],10)].selected = true;
      dayOptions[parseInt(ymd[2],10)].selected = true;
    }

    dateFieldDay.addEventListener('change', dateChangeHandler);
    dateFieldMonth.addEventListener('change', dateChangeHandler);
    dateFieldYear.addEventListener('change', dateChangeHandler);
    dateChangeHandler();

    if (!showOriginalFieldForDemo) {
      fieldDateOfBirth.type = 'hidden';
    }
  }

  //cart attributes edit
  fetch('/cart/update.js?csapp=aiod', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'attributes[Authority To Leave]=Yes'
  })
  .then(function(){});

});
